export default __webpack_public_path__ + "static/media/user_logo.f2d6f057.jpg";